"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var theme = _a.theme, columnGap = _a.columnGap;
    if (!columnGap) {
        return '';
    }
    return "column-gap: " + theme.sizes.default[columnGap] + ";";
});
